<template>
  <div class="step__boxes">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="step__box"
      @click="selectOption(item)"
    >
      {{ item.label }}
      <span class="step__circle">
        <svg height="35" width="35">
          <circle
            cx="20"
            cy="20"
            r="10"
            stroke="#e9eef3"
            stroke-width="2"
            fill="white"
          />
          Sorry, your browser does not support inline SVG.
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepBoxes",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectOption(item) {
      this.$emit("click", item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.step__boxes {
  display: flex;

  .step__box {
    cursor: pointer;
    background: white;
    padding: 0rem 0.5rem 0rem 1rem;
    margin-right: 1rem;
    vertical-align: middle;

    .step__circle {
      padding: 0;
      vertical-align: middle;
      padding-left: 10rem;
    }
  }
}
</style>
